// extracted by mini-css-extract-plugin
export default {"containerButtonsModal":"ConfirmDataTabForm_containerButtonsModal__f1zAB","primary":"ConfirmDataTabForm_primary__OGHbU"};